import React from 'react';
import { motion } from 'framer-motion';
export function Solution() {
  return <section className="bg-bordo text-crema py-20 px-4 md:px-8" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-118">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-119">
            La verdad es esta:
          </h2>
          <p className="text-xl md:text-2xl mb-4" data-id="element-120">
            La milanesa no es aburrida.
          </p>
          <p className="text-xl md:text-2xl font-bold text-dorado mb-12" data-id="element-121">
            Aburrido es hacerla siempre de la misma forma.
          </p>

          <p className="text-2xl mb-4" data-id="element-122">Y por eso nace:</p>
          <h3 className="text-4xl md:text-6xl font-serif font-bold text-dorado mb-8" data-id="element-123">
            🥩 La Biblia de la Milanesa
          </h3>
          <p className="text-lg md:text-xl max-w-2xl mx-auto" data-id="element-124">
            Una guía práctica para amantes de las milanesas y para personas que
            quieren resolver comidas rápidas, ricas y sin estrés.
          </p>
        </motion.div>
      </div>
    </section>;
}